import Vue from 'vue'
import Router from 'vue-router'
import auth from './auth'
import user from './user'
import home from './home'
import file from './file'
// import request from './request'
import templates from './templates'
import providers from './providers'
import requests from './requests'
import subscription from './subscription'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    auth,
    user,
    home,
    file,
    // request,
    templates,
    providers,
    requests,
    subscription,
    {
      path: '/',
      redirect: { name: 'auth.login-page' }
    },
    {
      path: '/service-unavailable',
      name: 'service-unavailable',
      component: () =>
        import(
          /* webpackChunkName: "service-unavailable" */ '@/views/error/ServiceUnavailable'
        )
    },
    {
      path: '*',
      name: 'page-not-found',
      component: () =>
        import(
          /* webpackChunkName: "page-not-found" */ '@/views/error/PageNotFound'
        )
    },
    {
      path: '/premium-settings',
      name: 'premium-settings',
      component: () =>
        import(
          /* webpackChunkName: "premium-settings" */ '@/views/error/PremiumSettings'
        )
    }
  ],
  //  this feature only works if the browser supports history.pushState
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },

  watch: {
    $route() {
      this.$store.dispatch('notification/getUnreadNotifications')
    }
  }
})
